'use strict';

import AvatarService from '@/services/avatarService';

let commitRef = null;
let agentsRequestTimeout = null;
let batchRequestAgents = [];
let contactsRequestTimeout = null;
let batchRequestContacts = [];

const queueAgentAvatarRequest = (agentId, commit) => {
  batchRequestAgents.push(agentId);
  commitRef = commit;

  if (agentsRequestTimeout) {
    clearTimeout(agentsRequestTimeout);
  }

  agentsRequestTimeout = setTimeout(() => {
    AvatarService.requestAvatarBatch(batchRequestAgents).then(({ data }) => {
      data.forEach(({ userId: agentId, avatar }) => {
        commitRef('setAgentAvatar', { agentId, avatar });
      });
    });
    batchRequestAgents = [];
  }, 50);
};

const queueContactAvatarRequest = (contactId, commit) => {
  batchRequestContacts.push(contactId);
  commitRef = commit;

  if (contactsRequestTimeout) {
    clearTimeout(contactsRequestTimeout);
  }

  contactsRequestTimeout = setTimeout(() => {
    AvatarService.requestCustomerAvatarBatch(batchRequestContacts).then(({ data }) => {
      data.forEach(({ userId: contactId, avatar }) => {
        commitRef('setContactAvatar', { contactId, avatar });
      });
    });
    batchRequestContacts = [];
  }, 50);
};

export default {
  registerAvatarConsumer({ dispatch }, { agentId, contactId, manualRequest }) {
    if (agentId) {
      dispatch('registerAgentAvatarConsumer', { agentId, manualRequest });
    }
    if (contactId) {
      dispatch('registerContactAvatarConsumer', { contactId, manualRequest });
    }
  },

  registerContactAvatarConsumer({ commit, getters }, { contactId, manualRequest }) {
    commit('registerContactAvatarConsumer', contactId);
    if (getters.getContactAvatar(contactId) === undefined && !manualRequest) {
      commit('setContactAvatar', { contactId, avatar: null });
      queueContactAvatarRequest(contactId, commit);
    }
  },

  registerAgentAvatarConsumer({ commit, getters }, { agentId, manualRequest }) {
    commit('registerAgentAvatarConsumer', agentId);
    if (getters.getAgentAvatar(agentId) === undefined && !manualRequest) {
      commit('setAgentAvatar', { agentId, avatar: null });
      queueAgentAvatarRequest(agentId, commit);
    }
  },

  unregisterAvatarConsumer({ commit }, { agentId, contactId }) {
    if (agentId) {
      commit('unregisterAgentAvatarConsumer', agentId);
    }
    if (contactId) {
      commit('unregisterContactAvatarConsumer', contactId);
    }
  },

  upsertAvatar({ commit, getters }, { agentId, contactId, avatar }) {
    let service;

    if (agentId) {
      const hasAvatar = getters.getAgentAvatar(agentId);
      service = hasAvatar ? AvatarService.updateAgentAvatar : AvatarService.createAgentAvatar;
    }

    if (contactId) {
      const hasAvatar = getters.getContactAvatar(contactId);
      service = hasAvatar ? AvatarService.updateContactAvatar : AvatarService.createContactAvatar;
    }

    if (!service) {
      return;
    }

    service(agentId || contactId, avatar).then(response => {
      const mutation = agentId ? 'setAgentAvatar' : 'setContactAvatar';

      commit(mutation, {
        agentId,
        contactId,
        avatar: response.data ? response.data.avatar : null
      });
    });
  }
};
